const i18nVariables = {
  // 1393 ----------- Remove -------------
  // APP
  //APP_NAME: process.env.REACT_APP_NAME,
  //APP_SHORT_NAME: process.env.REACT_APP_NAME,
  //APP_SIGN_IN: 'Sign in',

  // <b></b> tags parse-able with the parse() plugin from react-html-parser

  //APP_UNAUTHORIZED_MESSAGE: 'Unauthorized to view this Application',

  // Nav Menu
  //APP_SHORT_TITLE: process.env.REACT_APP_NAME,

  // Landing View
  APP_VALIDATION_INSTRUCTIONS:
    "Please select an unvalidated trip below to validate your travel",
  APP_SHOW_VALIDATED_TRIPS:
    "You can view the trips you have already validated or that have been processed by clicking either button below",
  APP_VALIDATED_TRIPS_BUTTON_TEXT: "View Validated Trips",
  APP_VALIDATED_INSTRUCTIONS: "Select a trip to review your validated trips",
  APP_PROCESSED_INSTRUCTIONS: "Select a trip to review your processed trips",
  APP_SHOW_NONVALIDATED_TRIPS:
    "You can view the trips you have not validated by clicking the button below",
  APP_NONVALIDATED_TRIPS_BUTTON_TEXT: "View Unvalidated Trips",
  APP_PROCCESSED_TRIPS_BUTTON_TEXT: "View Processed Trips",
  APP_NO_TRIPS: "There are no trips to validate at this time",
  APP_LOADING_MESSAGE: "Attempting to load trip information",
  APP_VIEW_ALL_TRIPS: "View All Trips",
  APP_DELEGATE_INSTRUCTIONS: "Please use the dropdown to filter trips per user",

  // Day List View
  APP_DAY_LIST_PROCESSED_INSTRUCTIONS:
    "This trip was available for validation in a previous period and has been sent to our vendor.",
  APP_DAY_LIST_INSTRUCTIONS:
    "Please ensure the following information for each day is correct",
  APP_DAY_LIST_VALIDATION: "Were you working on the following days?",
  APP_DAY_LIST_PROCESSED_EDIT_INSTRUCTIONS:
    "If the trip has already been processed in a previous BTVT monthly cycle, please submit a Service Gateway ticket. " +
    "If payroll withholdings have already been completed in Workday, the trip cannot be corrected.",
  APP_DAY_LIST_SUBMIT_INSTRUCTIONS:
    "Click 'Submit' to save your changes and move to the next trip requiring validation",
  APP_DAY_LIST_START_DATE_LABEL: "Start Date",
  APP_DAY_LIST_END_DATE_LABEL: "End Date",
  APP_DAY_LIST_YES_CHOICE: "Yes",
  APP_DAY_LIST_NO_CHOICE: "No",
  APP_DAY_LIST_CANCEL_BUTTON_LABVEL: "Cancel",
  APP_DAY_LIST_SUBMIT_BUTTON_LABVEL: "Submit",

  // Trip Creation View
  APP_TRIP_CREATION_INSTRUCTIONS:
    "Create a trip that was not recorded through Direct Travel",
  APP_TRIP_CREATION_SUBMIT_INSTRUCTIONS:
    "Click 'Create' to add your newly created trip into the BTVT system",
  APP_TRIP_CREATION_STEP_ONE: "Please select whom this trip is for:",
  APP_TRIP_CREATION_STEP_TWO: "Please select the start date for your trip",
  APP_TRIP_CREATION_STEP_THREE: "Please select the end date for your trip",
  APP_DAY_TRIP_CREATION_START_DATE_ERROR:
    "The start date cannot be greater than the end date",

  // Delegate View
  APP_DELEGATE_PICKER_INSTRUCTIONS:
    "Select, change, or remove your delegate in the field below.",
  APP_DELEGATE_DISCLAIMER_TITLE: "Disclaimer",
  APP_DELEGATE_DISCLAIMER:
    "The travel information being validated within the BTVT will be used to determine " +
    "if Chick-fil-A, Inc., your employer, will withhold payroll taxes for states in which you traveled for work. " +
    "By selecting a delegate to approve, edit and adjust your travel via the BTVT app, " +
    "you acknowledge that the information provided in this tool may ultimately impact your payroll " +
    "tax withholdings. While you will be able to continue to monitor and make adjustments in the " +
    "respective calendar in addition to a delegate's access, once the validation period has closed, " +
    "this tool cannot be used to correct any error that you or a delegate has made without administrator " +
    "action. Please ensure you are prudent in your selection of a delegate, and also that you " +
    "affirmatively deauthorize (within the BTVT) a delegate who is no longer appropriate, " +
    "for example, due to no longer having access or knowledge of your work travel schedule. " +
    "Upon assignment, all delegates will be required to review the instructional materials " +
    "provided to them by Benefits and Payroll Solutions. Chick-fil-A, Inc. does not provide " +
    "financial or tax advice to employees, and none is being provided in the BTVT.",
  APP_DELEGATE_DISCLAIMER_ACCEPT: "Accept",

  //Logo Alt Text
  APP_LOGO_ALT_TEXT: "Company Logo",

  APP_MASQUERADE: "Masquerade",
  APP_MASQUERADE_DIALOG_TEXT: "Select who you would like to masquerade as:",
  APP_MASQUERADE_DIALOG_ACCEPT: "Accept",
  APP_MASQUERADE_DIALOG_CANCEL: "Cancel",
  APP_CURRENT_MASQUERADE: "Masqueraded: ",
  APP_MASQUERADE_ACTIVATE: "Masquerade as a user",
  APP_MASQUERADE_DEACTIVATE: "Return to primary user",
  // -------------------------------------------Remove---------------------------------------------

  // APP
  APP_NAME: "Treasury Dashboard",
  APP_SHORT_NAME: "Treasury Dashboard",
  APP_SIGN_IN: "Sign in",

  APP_UNAUTHORIZED_MESSAGE: "Unauthorized to view this Application",
  APP_UNDEFINED_LOCATION_MESSAGE: "Please search for a location",

  // Nav Menu
  APP_SHORT_TITLE: "Treasury Dashboard",
  APP_MENU_LANDING: "Landing",
  APP_MENU_SIGN_OUT: "Sign out",
  APP_PROFILE_TOOLTIP: "Profile",
  APP_SELECT_LOCATION: "Select Location",

  // Landing Page
  APP_LANDING_PAGE_WELCOME: "Welcome",
  APP_LANDING_PAGE_SELECT_APP: "Select an Application",
  APP_LANDING_PAGE_SELECT_LOCATION: "Please select a location to continue",
  APP_LANDING_PAGE_TITLE: "Treasury Dashboard Home",

  // Location Selector
  APP_LOCATION_SELECTOR_SELECT: "Please Select a location",

  // Risk Analysis Excessive Activity
  APP_RISK_ANALYSIS_TITLE: "Risk Analysis",
  APP_RISK_ANALYSIS_START_DATE: "Start Date",
  APP_RISK_ANALYSIS_END_DATE: "End Date",

  // Delivery Partners
  APP_DELIVERY_PARTNERS_TITLE: "Delivery Partners",
  APP_DELIVERY_PARTNERS_TABLE_TITLE: "All Delivery Partners",
  APP_DELIVERY_PARTNERS_UPDATE_FORM: "Update Delivery Partner",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_SUBMIT: "Submit",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_NEXT: "Next",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_PARTNER_ID_LABEL: "Partner ID",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_PARTNER_ID_PLACEHOLDER:
    "Enter a Partner ID",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_VENDOR_NAME_LABEL: "Vendor Name",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_VENDOR_NAME_PLACEHOLDER:
    "Enter a Vendor Name",

  //SHERLOCK
  RISK_ANALYSIS_LOCATION_NUMBER: "Location",
  RISK_ANALYSIS_OPERATOR_NAME: "Operator Name",
  RISK_ANALYSIS_OPERATOR_LAST_EMAIL_DATE: "Date Last Email \nSent to Operator",
  RISK_ANALYSIS_MAX_RISK_SCORE: "Max Risk Probability (%)",
  RISK_ANALYSIS_COUNT_HIGH_RISK_SCORES: "Count High Risk Scores",
  RISK_ANALYSIS_AVG_RISK_RANK: "Avg Rank of Risk",
  RISK_ANALYSIS_AVG_RISK_PROB: "Avg Risk Prob",
  RISK_ANALYSIS_MAX_REFUND_AMOUNT: "Max Refund Amount",
  RISK_ANALYSIS_REFUND_AMOUNT: "Refund\nAmount",
  RISK_ANALYSIS_EMAIL: "Email",
  RISK_ANALYSIS_EMAIL_OPERATOR: "Operator?",
  RISK_ANALYSIS_EMAIL_FRC: "Email FRC?",
  RISK_ANALYSIS_RISK_LEVEL: "Enter Risk Level",
  RISK_ANALYSIS_TRANSACTION_NUMBER: "Transaction \n  Number",
  RISK_ANALYSIS_DATE: "Date",
  RISK_ANALYSIS_TIME: "Time",
  RISK_ANALYSIS_RISK_SCORE: "     Risk \nProbability",
  RISK_ANALYSIS_RISK_RANK: "Rank of \n   Risk",
  RISK_ANALYSIS_REFUND_TYPE: "Refund \n  Type",
  RISK_ANALYSIS_EXPL: "   Model \nExplanation",
  RISK_ANALYSIS_INACCURATE_EXPLS: "Inaccurate Model Explanation",
  RISK_ANALYSIS_SAVE_MODAL_TITLE:
    "Are you sure you want to save your feedback?",
  RISK_ANALYSIS_RESET_MODAL_TITLE:
    "Are you sure you want to clear your unsaved feedback?",
  RISK_ANALYSIS_SET_RISK_SCORE_MODAL_TITLE:
    "Set the risk score to apply to all transactions for this location.",
  RISK_ANALYSIS_SAVE_SUCCESS: "Save Successful",
  RISK_ANALYSIS_SAVE_PARTIAL_SUCCESS: "Save Partially Successful",
  RISK_ANALYSIS_SAVE_PARTIAL_MESSAGE: "The following feedback requests were not saved or notified, because other changes were already made to them and operators notified. Please review them and make any additional changes needed.",
  RISK_ANALYSIS_REQUEST_EMAIL: "treasuryalerts@chick-fil-a.com",
  RISK_ANALYSIS_MODAL_TITLE: "How would you like to Export?",

  //Bank Account Maintenance
  APP_BANK_ACCOUNT_MANAGEMENT_TITLE: "Bank Account Maintenance",
  APP_BANK_ACCOUNT_MNGMT_LOCATION_NUMBER: "Location Number",
  APP_BANK_ACCOUNT_MNGMT_BUSINESS_UNIT_NUM: "Business Unit Number",
  APP_BANK_ACCOUNT_MNGMT_BANK_ACC_OPEN_DATE: "Bank Account Open Date",
  APP_BANK_ACCOUNT_MNGMT_BANK_ACC_CLOSE_DATE: "Bank Account Close Date",
  APP_BANK_ACCOUNT_MNGMT_ACCOUNT_TYPE: "Bank Account Type",
  APP_BANK_ACCOUNT_MNGMT_TEMP_BUSINESS_UNIT_HEADER: "Temporary Business Unit",

  APP_BANK_ACCOUNT_MNGMT_ENTITY_NAME: "Entity Name",
  APP_BANK_ACCOUNT_MNGMT_PROJ_GRAND_OPEN_DATE: "Projected Grand Opening Date",
  APP_BANK_ACCOUNT_MNGMT_BUSINESS_UNIT_START_DATE: "R12 Assignment Start Date",
  APP_BANK_ACCOUNT_MNGMT_BUSINESS_UNIT_CLOSE_DATE: "R12 Assignment End Date",
  APP_BANK_ACCOUNT_MNGMT_OPERATOR_LEGAL_NAME: "Operator Legal Name",
  APP_BANK_ACCOUNT_MNGMT_OPERATOR_NUM: "Operator Number",
  APP_BANK_ACCOUNT_MNGMT_OPERATOR_EMAIL: "Operator Email",
  APP_BANK_ACCOUNT_MNGMT_LOCATION_NAME: "Location Name",
  APP_BANK_ACCOUNT_MNGMT_COUNTRY_CODE: "Country Code",
  APP_BANK_ACCOUNT_MNGMT_FEIN: "FEIN",
  APP_BANK_ACCOUNT_MNGMT_PARENT_ACC_NAME: "Parent Bank Account Name",
  APP_BANK_ACCOUNT_MNGMT_ROUTING_NUMBER: "Routing Number",
  APP_BANK_ACCOUNT_MNGMT_ACCOUNT_NUMBER: "Account Number",
  APP_BANK_ACCOUNT_MNGMT_POSITIVE_PAY: "Positive Pay",
  APP_BANK_ACCOUNT_MNGMT_FRACTIONAL_TOP: "Fractional Top",
  APP_BANK_ACCOUNT_MNGMT_FRACTIONAL_BOT: "Fractional Bottom",
  APP_BANK_ACCOUNT_MNGMT_ACTIVE_DATE: "CFA Account Active Date",
  APP_BANK_ACCOUNT_MNGMT_INACTIVE_DATE: "CFA Account Inactive Date",
  APP_BANK_ACCOUNT_MNGMT_ACCOUNT_NAME: "Bank Account Name",
  APP_BANK_ACCOUNT_MNGMT_TEMP_BU_ADD_BUTTON: "+ Add Temporary Business Unit",
  APP_BANK_ACCOUNT_MNGMT_TEMP_BU_HEADER: "Temporary Business Units",
  APP_BANK_ACCOUNT_MNGMT_PHASE: "Phase",
  APP_BANK_ACCOUNT_MNGMT_PARENT_BANK_ACC_NUM: "Parent Bank Account Number",
  APP_BANK_ACCOUNT_MNGMNT_SAVE_MODAL_TITLE:
    "Are you sure you want to save all modified Bank Accounts?",
  APP_BANK_ACCOUNT_MNGMNT_TEMP_BU_MODAL_TITLE:
    "Please use the fields below to create a placeholder Business Unit",
  APP_BANK_ACCOUNT_MNGMNT_TEMP_BU_USER_FEIN_INPUT_MODAL_TITLE:
    "Please use the space below to input a valid FEIN",
  APP_BANK_ACCOUNT_MNGMNT_SAVE_SUCCESS: "Save Successful",
  APP_BANK_ACCOUNT_MNGMNT_LOCATION_NUMBER: "Location Number",
  APP_BANK_ACCOUNT_MNGMNT_EXPORT_MODAL_TITLE: "How would you like to Export?",

  APP_BANK_ACCOUNT_MNGMT_SUB_ACCOUNTS: "Sub-Account Type",

  // Commission Rate History
  APP_BUSINESS_UNIT_COMMISSION_RATE_HISTORY_TITLE: "Commission Rate History",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_RATE_LABEL:
    "Commission Rate (%)",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_RATE_PLACEHOLDER:
    "Enter Commission Rate",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_LABEL: "Commission Fee ($)",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_PLACEHOLDER:
    "Enter Commission Fee",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_CALC_TYPE_LABEL:
    "Commission Calc Type",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_START_DATE_LABEL:
    "Commission Start Date",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_END_DATE_LABEL:
    "Commission End Date",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_CODE_LABEL:
    "Commission Tran Code",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_PLACEHOLDER:
    "Enter Commission Code",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_COMMISSION_RATE_LABEL:
    "Commission Rate (%)",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_COMMISSION_RATE_PLACEHOLDER:
    "Enter Commission Rate",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_COMMISSION_FEE_LABEL:
    "Commission Fee ($)",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_COMMISSION_FEE_PLACEHOLDER:
    "Enter Commission Fee",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_COMMISSION_CALC_TYPE_LABEL:
    "Commission Calc Type",

  APP_COMMISSION_HISTORY_ADD_FORM_TITLE: "Add Commission",
  APP_COMMISSION_HISTORY_UPDATE_FORM_TITLE: "Edit Commission",
  APP_COMMISSION_RATE_HISTORY_EXPORT: "Export",

  APP_COMMISSION_HISTORY_EDIT_FORM_TITLE: "Edit Commission History",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_GROSS_SALES_LABEL: "Tran Code",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_GROSS_SALES_PLACEHOLDER: "Enter Tran Code",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_START_DAY_LABEL: "Sales Week Start Day",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_START_DAY_WEEK_PLACEHOLDER: "Select a Day",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_END_DAY_LABEL: "Sales Week End Day",
  APP_DELIVERY_PARTNERS_UPDATE_END_DAY_PLACEHOLDER: "Select a Day",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_PAYMENT_DAY_LABEL: "Payment Day of Week",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_PAYMENT_DAY_PLACEHOLDER: "Select a Day",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_LAG_TERM_LABEL: "Lag Term",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_LAG_TERM_PLACEHOLDER: "Lag Term",

  APP_DELIVERY_PARTNERS_UPDATE_FORM_ERROR:
    "There was an error while submitting the form. Please try again.",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_SUCCESS: "Submission Success!",
  APP_DELIVERY_PARTNERS_DELETE_SUCCESS: "Delete Success!",
  APP_DELIVERY_PARTNERS_DELETE_FAILURE: "Delete Failure",

  // Overrides Delete All For Partner Popup
  APP_BUSINESS_UNIT_OVERRIDES_DELETE_ALL_FOR_PARTNER_BUTTON: "Delete Overrides",
  APP_BUSINESS_UNIT_OVERRIDES_DELETE_ALL_FOR_PARTNER_TITLE:
    "Delete location overrides for this partner?",
  APP_BUSINESS_UNIT_OVERRIDES_DELETE_ALL_FOR_PARTNER_MESSAGE:
    "Choose whether to Export & Delete, Delete only, or Cancel",
  APP_BUSINESS_UNIT_OVERRIDES_EXPORT_DELETE_LABEL: "Export & Delete",
  APP_BUSINESS_UNIT_OVERRIDES_DELETE_LABEL: "Delete",
  APP_BUSINESS_UNIT_OVERRIDES_CANCEL_LABEL: "Cancel",

  APP_DELIVERY_PARTNERS_ADD_FORM_TITLE: "Add Delivery Partner",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_TITLE: "Edit Delivery Partner",
  APP_DELIVERY_PARTNERS_UPDATE_FORM_CLOSE: "Close",

  // Business Unit Overrides
  APP_BUSINESS_UNIT_OVERRIDES_TITLE: "Location Overrides",
  APP_BUSINESS_UNIT_OVERRIDES_ID: "Override ID",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM: "Update Delivery Partner",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_SUBMIT: "Submit",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_PARTNER_ID_LABEL:
    "Delivery Partner ID",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_PARTNER_ID_PLACEHOLDER:
    "Enter a Partner ID",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_LOCATION_NUMBER_LABEL:
    "Location Number",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_LOCATION_PLACEHOLDER:
    "Search for a Location",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_LOCATION_LIMIT:
    "Limit of 5 characters",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_START_TIMESTAMP_LABEL: "Start Date",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_START_TIMESTAMP_PLACEHOLDER:
    "Select a Date",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_END_TIMESTAMP_LABEL: "End Date",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_END_TIMESTAMP_PLACEHOLDER:
    "Select a Date",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_DELETE: "Delete",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_ERROR:
    "There was an error while submitting the form. Please try again.",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_SUCCESS: "Submission Success!",

  APP_BUSINESS_UNIT_OVERRIDES_ADD_FORM_TITLE: "Add Location Override",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_TITLE: "Edit Location Override",
  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_CLOSE: "Close",

  APP_BUSINESS_UNIT_OVERRIDES_EMPTY_TABLE:
    "No Location Overrides for this Delivery Partner",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_NOT_APPLICABLE: "N/A",
  APP_BUSINESS_UNIT_OVERRIDES_EXPORT: "Export",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE: "Import Location Overrides",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_TITLE: "Import Location Overrides",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUBMIT_TEXT: "Save",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_RESET_TEXT: "Reset",
  APP_TEMP_BUSINESS_UNIT_INSERT_IMPORT_MODAL_SUBMIT_TEXT: "Insert",

  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUCCESS: "Import Successful",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_CLOSE: "Close",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_ERRORS: "errors",
  APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_INVALID_LOCATION:
    " is not a valid location number",

  APP_BUSINESS_UNIT_OVERRIDES_UPDATE_FORM_CLEAR_TIMESTAMP_BUTTON: "Clear",

  APP_ARMORED_CAR_TITLE: "Armored Car",

  APP_ARMORED_CAR_SEARCH_TITLE: "Search Business Units",
  APP_ARMORED_CAR_SEARCH_SUBMIT: "Search",
  APP_ARMORED_CAR_SEARCH_SHOW_ALL: "Show All",
  APP_ARMORED_CAR_SEARCH_CREATE: "Create Business Unit",
  APP_ARMORED_CAR_SEARCH_LOCATION_NUMBER_LABEL: "Location Number",
  APP_ARMORED_CAR_SEARCH_LOCATION_NUMBER_PLACEHOLDER: "",
  APP_ARMORED_CAR_SEARCH_BUSINESS_UNIT_NUMBER_LABEL: "Business Unit Number",
  APP_ARMORED_CAR_SEARCH_BUSINESS_UNIT_NUMBER_PLACEHOLDER: "",
  APP_ARMORED_CAR_SEARCH_BANK_ACCOUNT_NAME_LABEL: "Bank Account Name",
  APP_ARMORED_CAR_SEARCH_BANK_ACCOUNT_NAME_PLACEHOLDER: "",
  APP_ARMORED_CAR_SEARCH_BANK_ACCOUNT_NUMBER_LABEL: "Bank Account Number",
  APP_ARMORED_CAR_SEARCH_BANK_ACCOUNT_NUMBER_PLACEHOLDER: "",
  APP_ARMORED_CAR_SEARCH_ACCOUNT_STATUS_LABEL: "Account Status",
  APP_ARMORED_CAR_SEARCH_ACCOUNT_STATUS_PLACEHOLDER: "",
  APP_ARMORED_CAR_SEARCH_OPERATOR_NAME_LABEL: "Operator Name",
  APP_ARMORED_CAR_TABLE_LOCATION_TYPE_SELECT_PLACEHOLDER:
    "Filter location type...",
  APP_ARMORED_CAR_TABLE_COUNTRY_CODE_SELECT_PLACEHOLDER: "Filter country...",
  APP_ARMORED_CAR_TABLE_ACCOUNT_VISIBILITY_SELECT_PLACEHOLDER:
    "Filter account options...",

  APP_ARMORED_CAR_CREATE_CANCEL: "Cancel",
  APP_ARMORED_CAR_CREATE_SUBMIT: "Submit",
  APP_ARMORED_CAR_DOWNLOAD_LABEL: "Export CSV",
  APP_ARMORED_CAR_EXPORT_ALL_TO_ORACLE_ARCS_LABEL: "Trigger Oracle Export",
  APP_ARMORED_CAR_RESULTS_TITLE: "Business Units",
  APP_ARMORED_CAR_TABLE_SEARCH_PLACEHOLDER: "Filter search results...",
  APP_ARMORED_CAR_EDIT_TITLE: "Edit Business Unit",
  APP_ARMORED_CAR_CREATE_NEW_TITLE: "Create New Account",

  APP_ARMORED_CAR_ACTIVE_ACCOUNT_TOGGLE_TEXT: "Active Accounts",
  APP_ARMORED_CAR_NO_SMART_SAFE_TOGGLE_TEXT: "No Smart Safes",
  APP_ARMORED_CAR_COMPANY_OWNED_TOGGLE_TEXT: "Company Owned",

  APP_ARMORED_CAR_FORM_PHASE_LABEL: "Phase",
  APP_ARMORED_CAR_FORM_LOCATION_LABEL: "Location",
  APP_ARMORED_CAR_FORM_BUSINESS_UNIT_LABEL: "Business Unit",
  APP_ARMORED_CAR_FORM_OWNER_OPERATOR_LABEL: "Owner/Operator",
  APP_ARMORED_CAR_FORM_ENTITY_NAME_LABEL: "Entity Name",
  APP_ARMORED_CAR_FORM_OPERATING_FEIN_LABEL: "Operating FEIN",
  APP_ARMORED_CAR_FORM_LOCATION_NAME_LABEL: "Location Name",
  APP_ARMORED_CAR_FORM_SMART_SAFE_LABEL: "Smart Safe",
  APP_ARMORED_CAR_FORM_OPERATIONS_START_DATE_LABEL: "Operations Start Date",
  APP_ARMORED_CAR_FORM_OPERATIONS_END_DATE_LABEL: "Operations End Date",
  APP_ARMORED_CAR_FORM_LEAD_DAYS_LABEL: "Change Ordering Lead Days",
  APP_ARMORED_CAR_FORM_CEO_COMPANY_ID_LABEL: "CEO Company ID",
  APP_ARMORED_CAR_FORM_CEO_ID_LOGIN_LABEL: "CEO ID Login",
  APP_ARMORED_CAR_FORM_CEO_TEMP_PASSWORD_LABEL: "CEO Temp Password",
  APP_ARMORED_CAR_FORM_CEO_ORDER_DEADLINE_LABEL: "Deadline for CEO Orders",
  APP_ARMORED_CAR_FORM_TOUCH_TONE_ORDER_DEADLINE_LABEL:
    "Touch Tone Order Deadline",
  APP_ARMORED_CAR_FORM_ARMORED_CAR_SERVICE_LABEL: "Armored Car Service",
  APP_ARMORED_CAR_FORM_SERVICING_DAYS_LABEL: "Servicing Days",
  APP_ARMORED_CAR_FORM_TRANSPORT_BRANCH_LABEL: "Transport Branch",
  APP_ARMORED_CAR_FORM_ARMORED_CAR_FEE_LABEL: "Armored Car Fee",
  APP_ARMORED_CAR_FORM_BANK_NAME_LABEL: "Bank Name",
  APP_ARMORED_CAR_FORM_BANK_ACCOUNT_NUMBER_LABEL: "Bank Account #",
  APP_ARMORED_CAR_FORM_BANK_ROUTING_NUMBER_LABEL: "Bank ACH Routing Number",
  APP_ARMORED_CAR_FORM_ORACLE_BANK_CHANGE_LABEL: "Oracle Bank Change",
  APP_ARMORED_CAR_FORM_CASH_PROCESSING_VAULT_LABEL: "Cash Procesing Vault",
  APP_ARMORED_CAR_FORM_SAFE_SIZE_LABEL: "Safe Size",
  APP_ARMORED_CAR_FORM_SMART_SAFE_SLEEVE_LABEL: "Smart Safe Sleeve",
  APP_ARMORED_CAR_FORM_FCR_EXPENSE_LABEL: "FCR Monthly Expense",
  APP_ARMORED_CAR_FORM_TOUCH_TONE_PHONE_NUMBER_LABEL: "Touch Tone Phone Number",
  APP_ARMORED_CAR_FORM_TOUCH_TONE_GENERIC_QUESTIONS_LABEL:
    "Touch Tone Generic Questions",
  APP_ARMORED_CAR_FORM_TOUCH_TONE_LOGIN_LABEL: "Touch Tone Login",
  APP_ARMORED_CAR_FORM_TOUCH_TONE_PASSWORD: "Touch Tone Password",
  APP_ARMORED_CAR_LOCATION_TYPE_CODE_LABEL: "Location Type Code",
  APP_ARMORED_CAR_R12_ASSIGNMENT_START_DATE_LABEL: "R12 Assignment Start Date",
  APP_ARMORED_CAR_R12_ASSIGNMENT_END_DATE_LABEL: "R12 Assignment End Date",
  APP_ARMORED_CAR_COUNTRY_CODE_LABEL: "Country Code",
  APP_ARMORED_CAR_BU_START_DATE_LABEL: "Creation Date",
  APP_ARMORED_CAR_BU_END_DATE_LABEL: "End Date",

  APP_ARMORED_CAR_CREATE_NEW_ACCOUNT_BUTTON: "Create New Account",
  APP_ARMORED_CAR_SAVE_ALL_BUSINESS_UNIT: "Save All",
  APP_ARMORED_CAR_CREATE_NEW_BUSINESS_UNIT: "Create BU",
  APP_ARMORED_CAR_IMPORT_AC_CSV: "Import CSV",
  APP_ARMORED_CAR_BU_IMPORT_FILE_TITLE: "Import BU CSV",
  APP_ARMORED_CAR_IMPORT_FAIL_COL_NUM: "Number of Columns is Incorrect",
  APP_ARMORED_CAR_IMPORT_FAIL_COL_NAME: "Incorrect Column Name(s)",
  APP_ARMORED_CAR_IMPORT_FAIL_COL_ORDER:
    "One or More Column(s) are Out of Order",
  APP_ARMORED_CAR_IMPORT_SUCCESS: "Import Successful",
  APP_ARMORED_CAR_IMPORT_FILE_CLOSE: "Close Window",

  // Editable Armored Car
  APP_EDITABLE_ARMORED_CAR_TITLE: "Editable Armored Car",
  // Armored Car Excel
  APP_ARMORED_CAR_EXCEL_TITLE: "Armored Car In Excel",

  //Armored Car Excel Column labels
  APP_ARMORED_CAR_EXCEL_OPERATOR_PREFERRED_NAME_LABEL:
    "Operator Preferred Name",
  APP_ARMORED_CAR_EXCEL_OPERATOR_FIRST_NAME_LABEL: "Operator First Name",
  APP_ARMORED_CAR_EXCEL_OPERATOR_LAST_NAME_LABEL: "Operator Last Name",
  APP_ARMORED_CAR_EXCEL_FEIN_LABEL: "FEIN",
  APP_ARMORED_CAR_EXCEL_BUSINESS_UNIT_START_DATE_LABEL:
    "Business Unit Start Date",
  APP_ARMORED_CAR_EXCEL_BUSINESS_UNIT_END_DATE_LABEL: "Business Unit End Date",
  APP_ARMORED_CAR_EXCEL_ACTIVE_LABEL: "active",
  APP_ARMORED_CAR_EXCEL_OPEN_DATE_LABEL: "Location Open Date",
  APP_ARMORED_CAR_EXCEL_LOCATION_TYPE_CODE_LABEL: "Location Type Code",
  APP_ARMORED_CAR_EXCEL_ISO_COUNTRY_CODE_LABEL: "Country",
  APP_ARMORED_CAR_EXCEL_CORPORATE_OWNED_LABEL: "Corporate Owned",
  APP_ARMORED_CAR_EXCEL_OPERATOR_FULL_NAME_LABEL: "Operator Full Name",
  APP_ARMORED_CAR_EXCEL_HAS_SMART_SAFE_LABEL: "Has Smart Safe",
  APP_ARMORED_CAR_EXCEL_BANK_ACCOUNT_START_DATE_LABEL:
    "Bank Account Start Date",
  APP_ARMORED_CAR_EXCEL_BANK_ACCOUNT_END_DATE_LABEL: "Bank Account End Date",
  APP_ARMORED_CAR_EXCEL_ARMORED_CAR_SERVICING_DAYS_LABEL:
    "Armored Car Servicing Days",
  APP_ARMORED_CAR_EXCEL_BANK_ACCOUNT_ROUTING_NUMBER_LABEL:
    "Bank Account Routing Number",
  APP_ARMORED_CAR_EXCEL_CHANGE_ORDERING_LEAD_DAYS_LABEL:
    "Change Ordering Lead Days",
  APP_ARMORED_CAR_EXCEL_CEO_LOGIN_ID_LABEL: "CEO Login ID",
  APP_ARMORED_CAR_EXCEL_CEO_TEMPORARY_PASSWORD_LABEL: "CEO Temporary Password",
  APP_ARMORED_CAR_EXCEL_CEO_ORDER_DEADLINE_LABEL: "CEO Order Deadline",
  APP_ARMORED_CAR_EXCEL_ARMORED_CAR_TRANSPORT_BRANCH_LABEL:
    "Armored Car Transport Branch",
  APP_ARMORED_CAR_EXCEL_MONTHLY_ARMORED_CAR_FEE_LABEL:
    "Monthly Armored Car Fee",
};

export default i18nVariables;
